import { P, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled(P)`
  color: ${paletteHelper('textSecondary')};
  padding-bottom: ${spacingHelper('large')};
  width: 100%;
`;

const Part1 = styled.span`
  &::after {
    content: ' ';
  }
`;

const Part2 = styled.span`
  font-weight: 700;
`;

interface LeadingResultsBannerProps {
  part2?: string | null;
  part1?: string | null;
}

export const SearchLandingPageResultsLeadingBanner: FunctionComponent<
  LeadingResultsBannerProps
> = ({ part1, part2 }) => {
  return (
    <Container variant="subtitle02">
      {part1 && <Part1>{part1}</Part1>}
      {part2 && <Part2>{part2}</Part2>}
    </Container>
  );
};
